/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserInfoSupervisorLicenseReferencesInner } from './userInfoSupervisorLicenseReferencesInner';


/**
 * 
 */
export interface PartialUserInfoSupervisorLicense { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    status?: PartialUserInfoSupervisorLicense.StatusEnum;
    /**
     * 
     */
    references?: Array<UserInfoSupervisorLicenseReferencesInner>;
    /**
     * 
     */
    licenseFrom?: string;
    /**
     * 
     */
    licenseTo?: string;
    /**
     * 
     */
    licenseAccountId?: number;
    /**
     * 
     */
    licenseAccountName?: string;
    /**
     * 
     */
    organisationId?: number;
    /**
     * 
     */
    organisationName?: string;
}
export namespace PartialUserInfoSupervisorLicense {
    export type StatusEnum = 'active' | 'archived' | 'expired' | 'trial';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Archived: 'archived' as StatusEnum,
        Expired: 'expired' as StatusEnum,
        Trial: 'trial' as StatusEnum
    };
}


